<template>
  <nuxt-link v-if="visible" :to="result.path" class="flex items-center leading-none py-1 text-gray-800 dark:text-gray-100">
    <o-icon :icon="result.data.icon" class="mr-4" />
    <div>
      <p class="my-1">
        {{ $t(result.data.label) }}
      </p>
      <p class="text-gray-600 text-sm dark:text-gray-300">
        {{ $t(result.data.info) }}
      </p>
    </div>
  </nuxt-link>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visible () {
      return this.isGateEnabled && ((this.isGrantAllowed && this.isFeatureEnabled) || this.isUserOwner)
    },
    isGrantAllowed () {
      const item = this.result.data

      // Check required permissions of page
      const grants = item.path ? this.$grants.route(item.path) : null

      if (!grants) {
        return true
      }

      const allowed = this.$grants.all(grants)

      if (allowed) {
        return true
      }

      return allowed
    },
    isFeatureEnabled () {
      const item = this.result.data

      // Check required permissions of page
      const features = item.path ? this.$features.route(item.path) : null

      if (!features) {
        return true
      }

      const allowed = this.$features.all(features)

      return allowed
    },
    isGateEnabled () {
      const item = this.result.data

      // Check required permissions of page
      const gates = item.path ? this.$gates.route(item.path) : null

      if (!gates) {
        return true
      }

      const allowed = this.$gates.all(gates)

      return allowed
    },
  }
}
</script>
